module.exports = __webpack_public_path__ + "static/media/May_2026_1.49779229.webp";